
/**
 * Checks if given show has given feature enabled.
 *
 * @param {object} show          Show object.
 * @param {Array}  show.features Show features.
 * @param {string} feature       Feature to check.
 * @returns {boolean} If the show has the feature.
 */
export const hasFeature = ({ features }, feature) =>
    features.includes(feature);

/**
 * Enum-like object representing backend `Feature` enum values. These values
 * should match the enum defined in `App\Enums\Feature` php class.
 */
export const Feature = {
    APIAccess: 'APIAccess',
    ArchivePlayer: 'ArchivePlayer',
    ColorCustomization: 'ColorCustomization',
    CTAButton: 'CTAButton',
    DownloadButton: 'DownloadButton',
    EasyHosting: 'EasyHosting',
    HiddenPoweredBy: 'HiddenPoweredBy',
    ShareButton: 'ShareButton',
    SpeedRewind: 'SpeedRewind',
    StickyPlayers: 'StickyPlayers',
    SubscribeButton: 'SubscribeButton',
    TrackPlayer: 'TrackPlayer',
    Transcriptions: 'Transcriptions',
    Analytics: 'Analytics',
    EmailSupport: 'EmailSupport',
    PremiumSupport: 'PremiumSupport',
};

/**
 * Checks if given show has given import status.
 *
 * @param {object} show               Show object.
 * @param {number} show.importStatus Show import status.
 * @param {string} status            Import status to check.
 * @returns {boolean} If the show has the import status.
 */
export const hasImportStatus = ({ importStatus }, status) => importStatus === status;

/**
 * Enum-like object representing backend `ShowImportStatus` enum values. These values
 * should match the enum defined in `App\Enums\ShowImportStatus` php class.
 */
export const ImportStatus = {
    NotApplicable: 0,
    Pending: 1,
    Completed: 2,
    Error: 3,
};
